import { Injectable, Injector } from '@angular/core';
import { map } from 'rxjs/operators';
import { BsModalService } from 'ngx-bootstrap/modal';

import { ApplicationApiService } from 'src/app/shared/services';
import { RequestPermissionComponent } from 'src/app/shared/components';
import { ReleaseAuthorization } from 'src/app/shared/components/request-permission/shared/model';

@Injectable()
export class RequestPermissionService extends ApplicationApiService {
  constructor(
    private modalService: BsModalService,
    protected injector: Injector
  ) {
    super(injector);
  }

  public getPermission(namespace: string, action: string, msg: string = null): Promise<ReleaseAuthorization> {
    return new Promise<ReleaseAuthorization>((resolve, reject) => {
      this.http.post('/api/accounts/release-authorization/', { namespace, action }).pipe(
        map(res => res)
      ).subscribe(auth => resolve(auth), err => {
        const modal = this.modalService.show(RequestPermissionComponent, { class: 'modal-sm' });
        modal.content.setOption(resolve, reject, namespace, action, msg);
      });
    });
  }
}
